module.exports = __webpack_public_path__ + "static/design02-bd750477d50933cffbd412113aa17ece.png";